import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsDashboard from "../../SubTabsDashboard.js";
import { isSuperAdmin } from "./../../helpers/user.js";

import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class DashboardBudgetLogistics extends Component{ 

    constructor(props){
      super(props);

      this.state={
          finalbudgetyear:[],
          modalTitle:"",
          bugetyearid:0,
          fyname_y: "",
		      regionname_w: "",
		      warehousename_w: "",
		      origin_charges_y: "",
		      freight_y: "",
		     destination_charges_y: "",
		     customs_duties_y: "",
		     vat_y: "",
		     warehousing_y: "",
		     kitting_vas_y: "",
		     last_delivery_mile_y: "",
		     return_flow_y: "",
		     additional_fees_y: "",
		     purchases_costs_y: "",
         transferts_costs_y:"",
		     total_budget_year_y: "",
        

         finalbudgetregion:[],
          bugetregionid:0,
          fyname_r: "",
		      regionname_r: "",
		      warehousename_r: "",
		      origin_charges_r: "",
		      freight_r: "",
		     destination_charges_r: "",
		     customs_duties_r: "",
		     vat_r: "",
		     warehousing_r: "",
		     kitting_vas_r: "",
		     last_delivery_mile_r: "",
		     return_flow_r: "",
		     additional_fees_r: "",
		     purchases_costs_r: "",
         transferts_costs_r:"",
		     total_budget_region_r: "",

          CountryNameFilter:"",
          Country0NameFilter:"",
          RegionNameFilter:"",
          YearNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          BugetYearIdFilter:"",
          CurrentYearFilter:"",
          finalbudgetyearWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          warehouseNames: [],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,

          BugetRegionIdFilter:"",
          FyNameOFilter: "",
		      RegionNameOFilter: "",
          finalbudgetregionWithoutFilter:[],

          budgetyearhistory:[],
          modalTitle:"",
          budgetyearhistoryid:0,
          budgetyearid_y_hist:"",
          fyname_y_hist: "",
		      origin_charges_y_hist:"",
		      freight_y_hist: "",
		     destination_charges_y_hist: "",
		     customs_duties_y_hist: "",
		     vat_y_hist: "",
		     warehousing_y_hist: "",
		     kitting_vas_y_hist: "",
		     last_delivery_mile_y_hist: "",
		     return_flow_y_hist: "",
		     additional_fees_y_hist: "",
		     purchases_costs_y_hist: "",
         transferts_costs_y_hist:"",
		     total_budget_yarehouse_y_hist: "",
         comment_y_hist: "",
         update_y_hist:"",

      }
  }

  FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var RegionNameFilter = this.state.RegionNameFilter;
    var YearNameFilter = this.state.YearNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var BugetYearIdFilter = this.state.BugetYearIdFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;

    var filteredData=this.state.finalbudgetyearWithoutFilter.filter(
        function(el){
            return el.fyname_y.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.bugetyearid.toString().toLowerCase().includes(
                BugetYearIdFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({finalbudgetyear:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.finalbudgetyearWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({finalbudgetyear:sortedData});

}


FilterFnO(){
  var RegionNameOFilter = this.state.RegionNameOFilter;
  var FyNameOFilter = this.state.FyNameOFilter;
  var BugetRegionIdFilter = this.state.BugetRegionIdFilter;

  var filteredData=this.state.finalbudgetregionWithoutFilter.filter(
      function(el){
          return el.fyname_r.toString().toLowerCase().includes(
              FyNameOFilter.toString().trim().toLowerCase()
          )&&  
              el.bugetregionid.toString().toLowerCase().includes(
                BugetRegionIdFilter.toString().trim().toLowerCase()
          )&&  
          el.regionname_r.toString().toLowerCase().includes(
            RegionNameOFilter.toString().trim().toLowerCase()
      )
      }
  );

  this.setState({finalbudgetregion:filteredData});

}

sortResultO(prop,asc){
var sortedData=this.state.finalbudgetregionWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({finalbudgetregion:sortedData});

}

runFunction = () => {
  axiosService.post('/run-save-budget/')
      .then(response => {
          console.log('Function executed successfully:', response.data);
          // Handle the response as needed
      })
      .catch(error => {
          console.error('Error executing function:', error);
          // Handle errors
      });
};

changeComment_y_hist =(e)=>{
  this.setState({comment_y_hist:e.target.value});
}


changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeYearNameFilter = (e)=>{
    this.state.YearNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }


changeBugetYearIdFilter = (e)=>{
    this.state.BugetYearIdFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }

  changeFyNameOFilter = (e)=>{
    this.state.FyNameOFilter=e.target.value;
    this.FilterFnO();
  }

  changeRegionNameOFilter = (e)=>{
    this.state.RegionNameOFilter=e.target.value;
    this.FilterFnO();
  }

  changeBugetRegionIdFilter = (e)=>{
    this.state.BugetRegionIdFilter=e.target.value;
    this.FilterFnO();
  }

refreshList = () => {
    axiosService.get('/finalbudgetyear/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ finalbudgetyear: data, finalbudgetyearWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  refreshListRegion = () => {
    axiosService.get('/finalbudgetregion/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ finalbudgetregion: data, finalbudgetregionWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


  refreshListYearHistory = () => {
    axiosService.get('/budgetyearhistory/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ budgetyearhistory: data, budgetyearhistoryWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

componentDidMount(){
  this.refreshList();
  this.refreshListRegion();
  this.refreshListYearHistory();
}

componentWillUnmount() {
  // Clean up the interval when the component unmounts
  clearInterval(this.createClickInterval);
}

  



editClick(dep) {
  this.setState({
    modalTitle: "Edit Save",
    bugetyearid: dep.bugetyearid,
    fyname_y: dep.fyname_y,
    origin_charges_y:  dep.origin_charges_y,
    freight_y: dep.freight_y,
    destination_charges_y: dep.destination_charges_y,
    customs_duties_y: dep.customs_duties_y,
    vat_y: dep.vat_y,
    warehousing_y: dep.warehousing_y,
    kitting_vas_y: dep.kitting_vas_y,
    last_delivery_mile_y: dep.last_delivery_mile_y,
    return_flow_y: dep.return_flow_y,
    additional_fees_y: dep.additional_fees_y,
    purchases_costs_y: dep.purchases_costs_y,
    transferts_costs_y:dep.transferts_costs_y,
    total_budget_year_y: dep.total_budget_year_y,
    comment_y_hist: "",
    initialComment_y:"",
    isEditClicked: true,
  });
}



updateClick() {
  const { bugetyearid, fyname_y ,origin_charges_y,freight_y,destination_charges_y, customs_duties_y, vat_y, warehousing_y,
    kitting_vas_y,  last_delivery_mile_y,  return_flow_y, additional_fees_y, purchases_costs_y, total_budget_year_y, comment_y_hist, initialComment_y_hist,
    budgetyearid_y_hist, fyname_y_hist ,origin_charges_y_hist,freight_y_hist,destination_charges_y_hist, customs_duties_y_hist, vat_y_hist, warehousing_y_hist,
    kitting_vas_y_hist,  last_delivery_mile_y_hist,  return_flow_y_hist, additional_fees_y_hist, purchases_costs_y_hist, total_budget_year_y_hist } = this.state;
  
    axiosService.post('/budgetyearhistory/', {
      budgetyearid_y_hist:  this.state.bugetyearid,
      fyname_y_hist:  this.state.fyname_y,
      origin_charges_y_hist:  this.state.origin_charges_y,
      freight_y_hist: this.state.freight_y,
      destination_charges_y_hist: this.state.destination_charges_y,
      customs_duties_y_hist: this.state.customs_duties_y,
      vat_y_hist: this.state.vat_y,
      warehousing_y_hist: this.state.warehousing_y,
      kitting_vas_y_hist: this.state.kitting_vas_y,
      last_delivery_mile_y_hist: this.state.last_delivery_mile_y,
      return_flow_y_hist: this.state.return_flow_y,
      additional_fees_y_hist: this.state.additional_fees_y,
      purchases_costs_y_hist: this.state.purchases_costs_y,
      transferts_costs_y_hist: this.state.transferts_costs_y,
      total_budget_year_y_hist: this.state.total_budget_year_y,
      comment_y_hist: this.state.comment_y_hist
    })
    .then(result => {
      alert('Save successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


createClick() {

  axiosService.post('/budgetsave/', {
    savename: "budgetsave"
  })
    .then(result => {
      alert('Budget saved');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

budgetUpdateClick() {

  axiosService.post('/budgetupdate/', {
    updatename: "budgetupdate"
  })
    .then(result => {
      alert('Budget update');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}


render(){
  const {
      finalbudgetyear,
      modalTitle,
      bugetyearid,
      fyname_y,
		  regionname_w,
		  warehousename_w,
		  origin_charges_y,
		  freight_y,
		 destination_charges_y,
		customs_duties_y,
		vat_y,
		     warehousing_y,
		     kitting_vas_y,
		     last_delivery_mile_y,
		     return_flow_y,
		     additional_fees_y,
		     purchases_costs_y,
         transferts_costs_y,
		     total_budget_year_y,
         comment_y,
         

         finalbudgetregion,
         bugetregionid,
         fyname_r,
         regionname_r,
         warehousename_r,
         origin_charges_r,
         freight_r,
        destination_charges_r,
        customs_duties_r,
        vat_r,
        warehousing_r,
        kitting_vas_r,
        last_delivery_mile_r,
        return_flow_r,
        additional_fees_r,
        purchases_costs_r,
        transferts_costs_r,
        total_budget_region_r,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear,

      budgetyearhistoryid,
          budgetyearid_y_hist,
          fyname_y_hist,
		      origin_charges_y_hist,
		      freight_y_hist,
		     destination_charges_y_hist,
		     customs_duties_y_hist,
		     vat_y_hist,
		     warehousing_y_hist,
		     kitting_vas_y_hist,
		     last_delivery_mile_y_hist,
		     return_flow_y_hist,
		     additional_fees_y_hist,
		     purchases_costs_y_hist,
         transferts_costs_y_hist,
		     total_budget_yarehouse_y_hist,
         comment_y_hist,
         update_y_hist,

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsDashboard />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
onClick={()=>this.createClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Save all
</button>





<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Year Budget
    </div>
<div className="table-container-budget">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">


<th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Budget Year ID
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
    
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Origin Charges Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Freight Year 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Destination Charges Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Customs Duties Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Vat Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Warehousing Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Kitting & Vas Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Last Delivery Mile Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Return Flow Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Additional Fees Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Purchases Costs Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Costs Year
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Total Budget Year 
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Save
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {finalbudgetyear.map(dep=>
      <tr key={dep.bugetyearid} className="row-hover">
        <td className="table-text">{dep.bugetyearid ?? 'N/A'}</td>
        <td className="table-text">{dep.fyname_y ?? 'N/A'}</td>
<td className="table-text">{dep.origin_charges_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.origin_charges_y) : 'N/A'}</td>
<td className="table-text">{dep.freight_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.freight_y) : 'N/A'}</td>
<td className="table-text">{dep.destination_charges_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.destination_charges_y) : 'N/A'}</td>
<td className="table-text">{dep.customs_duties_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.customs_duties_y) : 'N/A'}</td>
<td className="table-text">{dep.vat_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.vat_y) : 'N/A'}</td>
<td className="table-text">{dep.warehousing_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.warehousing_y) : 'N/A'}</td>
<td className="table-text">{dep.kitting_vas_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.kitting_vas_y) : 'N/A'}</td>
<td className="table-text">{dep.last_delivery_mile_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.last_delivery_mile_y) : 'N/A'}</td>
<td className="table-text">{dep.return_flow_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.return_flow_y) : 'N/A'}</td>
<td className="table-text">{dep.additional_fees_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.additional_fees_y) : 'N/A'}</td>
<td className="table-text">{dep.purchases_costs_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.purchases_costs_y) : 'N/A'}</td>
<td className="table-text">{dep.transferts_costs_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.transferts_costs_y) : 'N/A'}</td>
<td className="table-text">{dep.total_budget_year_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.total_budget_year_y) : 'N/A'}</td>

          <td>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Save
          </button>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Region Budget
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFyNameOFilter}
      value={currentYear}
      placeholder="Filter"/>


      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameOFilter}
      placeholder="Filter"/>


      </div>
      Region
  </th>
 
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Origin Charges Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Freight Region 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Destination Charges Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Customs Duties Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Vat Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Warehousing Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Kitting & Vas Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Last Delivery Mile Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Return Flow Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Additional Fees Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Purchases Costs Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Costs Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Total Budget Region 
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {finalbudgetregion.map(dep=>
      <tr key={dep.bugetregionid} className="row-hover">
<td className="table-text">{dep.fyname_r ?? 'N/A'}</td>
<td className="table-text">{dep.regionname_r ?? 'N/A'}</td>
<td className="table-text">{dep.origin_charges_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.origin_charges_r) : 'N/A'}</td>
<td className="table-text">{dep.freight_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.freight_r) : 'N/A'}</td>
<td className="table-text">{dep.destination_charges_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.destination_charges_r) : 'N/A'}</td>
<td className="table-text">{dep.customs_duties_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.customs_duties_r) : 'N/A'}</td>
<td className="table-text">{dep.vat_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.vat_r) : 'N/A'}</td>
<td className="table-text">{dep.warehousing_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.warehousing_r) : 'N/A'}</td>
<td className="table-text">{dep.kitting_vas_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.kitting_vas_r) : 'N/A'}</td>
<td className="table-text">{dep.last_delivery_mile_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.last_delivery_mile_r) : 'N/A'}</td>
<td className="table-text">{dep.return_flow_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.return_flow_r) : 'N/A'}</td>
<td className="table-text">{dep.additional_fees_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.additional_fees_r) : 'N/A'}</td>
<td className="table-text">{dep.purchases_costs_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.purchases_costs_r) : 'N/A'}</td>
<td className="table-text">{dep.transferts_costs_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.transferts_costs_r) : 'N/A'}</td>
<td className="table-text">{dep.total_budget_region_r ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.total_budget_region_r) : 'N/A'}</td>

          <td>
            

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>


<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>bugetyearid</span>
          <input type="text" className="form-control" value={bugetyearid}
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <input type="text" className="form-control" value={fyname_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Origin Charges Year</span>
          <input type="text" className="form-control" value={origin_charges_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Freight Year</span>
          <input type="text" className="form-control" value={freight_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Destination Charges Year</span>
          <input type="text" className="form-control" value={destination_charges_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Customs Duties Year</span>
          <input type="text" className="form-control" value={customs_duties_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Vat Year</span>
          <input type="text" className="form-control" value={vat_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehousing Year</span>
          <input type="text" className="form-control" value={warehousing_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Kitting & Vas Year</span>
          <input type="text" className="form-control" value={kitting_vas_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Last Delivery Mile Year</span>
          <input type="text" className="form-control" value={last_delivery_mile_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Return Flow Year</span>
          <input type="text" className="form-control" value={return_flow_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Additional Fees Year</span>
          <input type="text" className="form-control" value={additional_fees_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Purchases Costs Year</span>
          <input type="text" className="form-control" value={purchases_costs_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Transferts Costs Year</span>
          <input type="text" className="form-control" value={transferts_costs_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Total Budget Year</span>
          <input type="text" className="form-control" value={total_budget_year_y}  
          style={{ fontSize: "12px" }} 
          />
        </div>


      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment_y_hist} onChange={this.changeComment_y_hist} 
          style={{ fontSize: "12px" }} 
          />
        </div>

        {bugetyearid === 0 ? (
          <button disabled={!isSuperAdmin()} type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick()}>
            Save
          </button>
        ) : null}

        {bugetyearid !== 0 ? (
          <button disabled={!isSuperAdmin()} type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick()}>
            Save
          </button>
        ) : null}

      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




